import { Slot } from './Slot'

export class Video extends Slot {
  /**
   * Slot name is used on display slots to create the GAM/GPT slot name.
   * For video, it serves no purpose other than to populate the
   * adUnitPath value, which gets used as a GPID in bid requests.
   */
  slotName = 'video'

  get id() {
    return 'video'
  }
}
